import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { BlobServiceClient } from "@azure/storage-blob";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import axios from "axios";

import { Table, Form, Button } from "react-bootstrap";

export default class UserOrders extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      userOrders: [],
      loadSpinnerOpen: false,
      currentOrderRow: "",
      invoiceHtml: "",
    };
    this.inputFile = React.createRef();
  }

  GetInvoice = (order) => {
    fetch(
      process.env.REACT_APP_API +
        "Sales/GetElasticCartInvoiceHtml/" +
        order.orderId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          // var d1 = document.getElementById("one");
          // if (d1) {
          //   d1.innerHTML = data;
          //   this.setState({ invoiceHtml: data });
          // }
          this.setState({ invoiceHtml: data }, () => {
            this.PrintInvoice();
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("getSubCategories err:" + error);
      });
  };

  PrintInvoice = () => {
    var printWindow = window.open("", "", "height=1000,width=1500");
    //var printWindow = window.open("", "");
    printWindow.document.write(this.state.invoiceHtml);
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };
  onPrintFinished = (status, printWindow) => {
    printWindow.close();
  };

  GetUserOrders = () => {
    this.ShowLoadSpinner();
    console.log(`Bearer ${this.context.userData.bearerToken}`);
    fetch(
      process.env.REACT_APP_API +
        "Sales/GetElasticCartOrdersByTenantId/" +
        this.context.userData.id,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.context.userData.bearerToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          this.HideLoadSpinner();
          return;
        }
        this.setState({ userOrders: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetUserOrders();
  }

  GetOrderStatus = (orderStatusId) => {
    var list = this.context.orderStatusTypes.filter(
      (e) => e.id == orderStatusId
    );
    if (list.length > 0) return list[0].statusName;
    return "";
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  handleInputChange = (e, i) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "":
        break;
    }
    this.setState({ userOrders: this.state.userOrders });
  };

  render() {
    if (this.context.userData.loginStatus !== "active") {
      return <Navigate to="/home" />;
    }

    const { userOrders, loadSpinnerOpen } = this.state;
    const { GetEcSettingValueByName } = this.context;

    return (
      <>
        {loadSpinnerOpen && <LoadSpinner open="true" />}
        <div className="mx-0 px-1 bg-white">
          <div className="row mt-2 mx-0 px-2">
            <div className="col-md-12">
              <h3 className="producttitlefontandsizeDesktop">
                <b>My Orders</b>
              </h3>
              <br />

              {/* Table for md and up */}
              <div className="d-none d-md-block">
                <Table
                  responsive
                  striped
                  bordered
                  className="cartviewtable cartDsn px-5"
                >
                  <thead className="bg-light text-center text-primary">
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Order No</th>
                      <th>Order Type</th>
                      <th>Store Name</th>
                      <th>Product</th>
                      <th>License</th>
                      <th>Start</th>
                      <th>Expiry</th>
                      <th>Paid Amount</th>
                      <th>Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userOrders
                      .sort((a, b) => (a.created < b.created ? 1 : -1))
                      .map((p, i) => (
                        <tr
                          key={p.orderId}
                          className="text-center align-middle"
                        >
                          <td>{i + 1}</td>
                          <td>
                            {this.context.GetInDateFormat(new Date(p.created))}
                          </td>
                          <td>{p.orderId}</td>
                          <td>
                            {["", "NEW", "UPGRADE", "RENEW"][p.orderType]}
                          </td>
                          <td>{p.businessName}</td>
                          <td>
                            {this.context.GetProductByType(p.productType).name}
                          </td>
                          <td>
                            {this.context.GetLicenseTypeNameById(p.licenseType)}
                          </td>
                          <td>
                            {this.context.GetInDateFormat(
                              new Date(p.licenseStart)
                            )}
                          </td>
                          <td>
                            {this.context.GetInDateFormat(
                              new Date(p.licenseEnd)
                            )}
                          </td>
                          <td>
                            {p.paidAmt.toLocaleString(
                              GetEcSettingValueByName("defaultLocale"),
                              {
                                style: "currency",
                                currency:
                                  GetEcSettingValueByName("defaultCurrency"),
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )}
                          </td>
                          <td>
                            <Button
                              size="sm"
                              onClick={() => this.GetInvoice(p)}
                            >
                              Print
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>

              {/* Cards for mobile */}
              <div className="d-md-none">
                {userOrders
                  .sort((a, b) => (a.created < b.created ? 1 : -1))
                  .map((p, i) => (
                    <div
                      key={p.orderId}
                      className="border rounded p-3 mb-3 shadow-sm"
                    >
                      <h6>
                        <b>Order #{p.orderId}</b>
                      </h6>
                      <p>
                        <b>Date:</b>{" "}
                        {this.context.GetInDateFormat(new Date(p.created))}
                      </p>
                      <p>
                        <b>Order Type:</b>{" "}
                        {["", "NEW", "UPGRADE", "RENEW"][p.orderType]}
                      </p>
                      <p>
                        <b>Store:</b> {p.businessName}
                      </p>
                      <p>
                        <b>Product:</b>{" "}
                        {this.context.GetProductByType(p.productType).name}
                      </p>
                      <p>
                        <b>License:</b>{" "}
                        {this.context.GetLicenseTypeNameById(p.licenseType)}
                      </p>
                      <p>
                        <b>Start:</b>{" "}
                        {this.context.GetInDateFormat(new Date(p.licenseStart))}
                      </p>
                      <p>
                        <b>Expiry:</b>{" "}
                        {this.context.GetInDateFormat(new Date(p.licenseEnd))}
                      </p>
                      <p>
                        <b>Paid:</b>{" "}
                        {p.paidAmt.toLocaleString(
                          GetEcSettingValueByName("defaultLocale"),
                          {
                            style: "currency",
                            currency:
                              GetEcSettingValueByName("defaultCurrency"),
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </p>
                      <div className="d-grid">
                        {/* <Button size="sm" onClick={() => this.GetInvoice(p)}>
                          Download Invoice
                        </Button> */}
                        <a
                          href={
                            this.context.GetEcSettingValueByName(
                              "storageBlobInvoiceUrl"
                            ) +
                            p.orderId +
                            ".html"
                          }
                          target="_blank"
                          className="download btn btn-primary"
                          style={{ textDecoration: "none" }}
                        >
                          <img src="html.png" height="30px" className="" />
                          &nbsp;&nbsp;Download Invoice
                        </a>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
